var _circle, _circle2, _ellipse, _ellipse2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 319,
    viewBox: "0 0 226 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 236,
    r: 140,
    fill: "url(#paint0_linear_513_3227)",
    fillOpacity: 0.62
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 169.5,
    r: 52.5,
    transform: "rotate(-90 68.5 169.5)",
    fill: "url(#paint1_linear_513_3227)",
    fillOpacity: 0.62
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.5,
    cy: 79.5,
    rx: 31.5,
    ry: 31.5,
    transform: "rotate(-90 194.5 79.5)",
    fill: "url(#paint2_linear_513_3227)",
    fillOpacity: 0.62
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.5,
    cy: 14.5,
    rx: 14.5,
    ry: 14.5,
    transform: "rotate(-90 183.5 14.5)",
    fill: "url(#paint3_linear_513_3227)",
    fillOpacity: 0.62
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_513_3227",
    x1: 183,
    y1: 145,
    x2: 16.5,
    y2: 357.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#095CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02BDF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_513_3227",
    x1: 105.444,
    y1: 131.259,
    x2: 86.6482,
    y2: 229.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C73EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AB5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_513_3227",
    x1: 216.667,
    y1: 56.5556,
    x2: 205.389,
    y2: 115.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C73EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AB5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_513_3227",
    x1: 193.704,
    y1: 3.93827,
    x2: 188.512,
    y2: 31.1481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C73EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AB5FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBottom);
export default __webpack_public_path__ + "static/media/sidebar-bottom.94602e2f895c21fab85dbbdc17ab9499.svg";
export { ForwardRef as ReactComponent };